import React, {useRef, useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import ReactDOM from "react-dom";
import { CustomBtn } from '../../button/button'
import { useDispatch, useSelector } from 'react-redux'
import { Padding } from '@mui/icons-material';
import buraqImage from '../../../assets/images/buraq.png'
import hodImage from '../../../assets/images/hod.png'
import almubarakImage from '../../../assets/images/almubarak.png'
import getBilim from '../../../assets/images/bilim2.png'


function XaosoftCard(props) {
    // console.log(props?.info)
    const image = useSelector((state)=>state.Api.imageServer)
    const [webSrn, setWebSrn] = useState(localStorage.getItem('WebSrn'));
    
    const [qrCodeData, setQRCodeData] = useState('');
    const [catchUrl, setCatchUrl] = useState('')

    const generateQRCode = () => {
        //console.log(props.info.RollNum)
        const dataObj = {
            roleNo: String(props.info.RollNum),
            name: props.info.Name_P,
        };
        //console.log(JSON.stringify(dataObj))
        const getQrCodeData = `wasilytech,${props.info.RollNum},${props.info.Name}`;
        setQRCodeData(getQrCodeData);
    };

    function separateLanguages(text) {
        const arabicRange = /[\u0600-\u06FF]/;
        const englishChars = [];
        const arabicChars = [];
    
        for (let char of text) {
            if (arabicRange.test(char)) {
                arabicChars.push(char);
            } else {
                if (char !== ' ') { // Check if the character is not a space
                    englishChars.push(char);
                } else {
                    arabicChars.push(char); // Preserve space in Arabic text
                }
            }
        }
    
        const englishText = englishChars.join('');
        const arabicText = arabicChars.join('');
    
        return arabicText;
    }
    
    

    
    useEffect(() => {
        generateQRCode();
        let currentUrl = window.location.href; // Get the current URL
        const containsStudents = currentUrl.includes('Students');

        if (containsStudents) {
            // Remove "Private/View/Students" from the URL
            currentUrl = currentUrl.replace("Private/Veiw/Students", "");
        } else {
            // Remove "Private/View/Students" from the URL
            currentUrl = currentUrl.replace("Private/Veiw/Teacher", "");
        }
        setCatchUrl(currentUrl)
        //console.log(currentUrl);
    }, []);
 
    const NewWindowContent = () => {
        return(
            <div className={`card${webSrn}`}>
                <div id="specificDiv" className="specificDivClass">
                <link rel="stylesheet" type="text/css" href={`${catchUrl}XaoSoft.css`} />
                <div className="card">
                <div className="card-header">
                        { 
                        webSrn == 9 ?
                        <>
                            <div className='image'>       
                                <img className="student-photo" src={hodImage} alt="Student Photo" />
                            </div>
                            <p style={{paddingTop:'3px', fontSize: '18px'}}>Hod Private School</p>
                        </>
                        :  webSrn == 10 ?
                        <>
                            <div className='image'>       
                                <img className="student-photo-almubarak" src={almubarakImage} alt="Student Photo" />
                            </div>
                            <p style={{paddingTop:'3px', fontSize: '18px'}}>المبارک ځلاند خصوصي ښوونځی</p>
                        </>
                        :  webSrn == 11 ?
                        <>
                            <div className='image'>       
                                <img className="student-photo-almubarak" src={buraqImage} alt="Student Photo" />
                            </div>
                            <p style={{paddingTop:'3px', fontSize: '18px'}}>براق خصوصی ښوونځي</p>
                        </>
                        : webSrn == 15 ?
                        <>
                            <div className='image'>       
                                <img className="student-photo-bilim" src={getBilim} alt="Student Photo" />
                            </div>
                            <p style={{ fontSize: '19px'}}>مکتب خصوصی بیلیم یورتی</p>
                        </>
                        : 
                        <></>
                        } 
                    {/* <p>مدرسه یا مکتب نوم</p> */}
                </div>
                <div className={props.info.studentOrTeacher == 'student' ? 'teacherLine student' : 'teacherLine teacher'} ></div>
                <div className='qrCode' style={ props.info.studentOrTeacher != 'student' ? {padding: '3px 62px'} : null}>
                    {qrCodeData && (
                        <div>
                            <QRCode value={qrCodeData} size={props.info.studentOrTeacher == 'student'? 70 : 80} />
                        </div>
                    )}
                </div>
               <div className="card-body" style={ props.info.studentOrTeacher != 'student' ? {padding: '7px 6px'} : null}>
                    <div className='rollNumber'>{props.info.studentOrTeacher != 'student'? null : props.info.RollNum}</div>
                    <div className={props.info.studentOrTeacher == 'student' ? 'student-info' : 'teacher-info'} >
                        <h2>{` ${props.info.Name_P}`}</h2>
                        <h2>{`${props.info.Name}`}</h2>
                        {props.info.studentOrTeacher == 'student'? <p>{props.info.FName_P}</p> : null}
                        {props.info.studentOrTeacher != 'student'? <h2 style={{fontSize:'22px', height:'20px'}}>{props.info.Job}</h2> 
                        : 
                        <h2>{separateLanguages(props.info.Class)}</h2>
                        }
                    </div> 
                    {/* <div><table className='tradeMark'><tr><td>انجينر0703131865 </td></tr></table></div> */}
                </div>
                <div className={props.info.studentOrTeacher == 'student' ? 'card-footer student' : 'card-footer teacher'} ></div>
                </div>
            </div>
            </div>
        )
    };

    const openNewWindow = () => {
        const newWindow = window.open('', '_blank', 'width=224,height=365');
        newWindow.document.body.innerHTML = '<div id="root"></div>'; // Create a root div in the new window
         // Create a link element for the CSS file
        const cssLink = newWindow.document.createElement('link');
        cssLink.rel = 'stylesheet';
        const url =window.location.href
        const catchUrl = url.replace("/Private/View/Students", "") 
        cssLink.href = `${catchUrl}/CardHTML.css`; // Replace 'path/to/your/css/file.css' with the actual path to your CSS file
        
        // Append the link element to the head of the new window's document
        newWindow.document.head.appendChild(cssLink);
        ReactDOM.render(<NewWindowContent />, newWindow.document.getElementById('root'));
    };

    return (
        <>
            <CustomBtn type="button" click={()=>openNewWindow()} data="Print Card  کارت چاپ کړئ" />
        </>
    );
}

export default XaosoftCard;
